// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Ls_B4","breadcrumb":"styles_breadcrumb___Ve0U"};